import { render, staticRenderFns } from "./CreateCostMapping.vue?vue&type=template&id=1e4310b0&scoped=true&"
import script from "./CreateCostMapping.vue?vue&type=script&lang=js&"
export * from "./CreateCostMapping.vue?vue&type=script&lang=js&"
import style0 from "./CreateCostMapping.vue?vue&type=style&index=0&id=1e4310b0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e4310b0",
  null
  
)

export default component.exports